import { render } from "./CommercialGroups.vue?vue&type=template&id=de9287b8&ts=true"
import script from "./CommercialGroups.vue?vue&type=script&lang=ts"
export * from "./CommercialGroups.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__